const policy = [{
  desc: '匹配政策',
  options: {
    url: '/comissionPolicyMatch/getPolicyIdList',
    method: 'post'
  }
}, {
  desc: '匹配政策',
  options: {
    url: '/insurancefc/matchPolictRateDateils',
    method: 'post'
  }
}, {
  desc: '留点配置',
  options: {
    url: '/ratereserved/busiFieldsPage',
    method: 'post'
  }
}, {
  desc: '新版政策保司列表查询',
  options: {
    url: '/newPolicyBatch/queryPolicySupplierInfo',
    method: 'get'
  }
}, {
  desc: '新版政策列表查询',
  options: {
    url: '/newPolicyBatch/getNewPolicyBatchList',
    method: 'post'
  }
}, {
  desc: '新版政策变更状态',
  options: {
    url: '/newPolicyBatch/changeStatus',
    method: 'post'
  }
}, {
  desc: '政策批次保存',
  options: {
    url: '/newPolicyBatch/savePolicyBatch',
    method: 'post'
  }
}, {
  desc: '政策批次日志',
  options: {
    url: '/newPolicyBatch/getNewLog',
    method: 'post'
  }
}, {
  desc: '复制政策',
  options: {
    url: '/newPolicyBatch/copyPolicy',
    method: 'post'
  }
}, {
  desc: '旧政策-复制政策',
  options: {
    url: '/newPolicyBatch/copyToNewPolicy',
    method: 'post'
  }
}, {
  desc: '查询历史批次作为模板',
  options: {
    url: '/newPolicyBatch/getNewPolicyBatchList',
    method: 'post'
  }
}, {
  desc: '旧版政策复制',
  options: {
    url: '/newPolicyBatch/batchClone',
    method: 'post'
  }
}, {
  desc: '旧版政策复制为新版',
  options: {
    url: '/newPolicyBatch/copyToNewPolicy',
    method: 'post'
  }
}, {
  desc: '营销方案-分页查询',
  options: {
    url: '/marketProgram/queryPageMarketing',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-编辑/添加',
  options: {
    url: '/marketProgram/addOrUpDateMarketing',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-删除',
  options: {
    url: '/marketProgram/deleteMarketing',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-状态开关',
  options: {
    url: '/marketProgram/updateMarketingStatus',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-账户余额显示',
  options: {
    url: '/marketProgram/accountBalance',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-营销方案全局设置查询',
  options: {
    url: '/marketProgram/queryMarketingProgramGlobalSettings',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '营销方案-红包分配比例设置',
  options: {
    url: '/marketProgram/editAllocationRateSettings',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '查询平台产品',
  options: {
    url: '/insType/querySupplierProductList',
    method: 'post'
  }
}]
export default policy



// WEBPACK FOOTER //
// ./src/api/policy.js